import useWebData from '../../hooks/useWebData';

const Clients = () => {
  const {webData}: any = useWebData();
  document.title = webData?.companyName + " | Clients";
  return (
    <div>Clients</div>
  )
}

export default Clients